import { MESApiService, spParameter } from "@dexteel/mesf-core";

export const getMonthlyReport = async (GradeId: number | undefined) => {
	const sqlParameters = [];
	if (GradeId) sqlParameters.push({ name: "GradeId", value: GradeId });

	const apiService = new MESApiService();
	return await apiService.callV2("[SWV].[GetMonthlyReport]", sqlParameters);
};
